import {useQuery, UseQueryOptions} from "@tanstack/react-query";
import {normalizePage, Page, Sort} from "@/types/page.ts";
import api from "@/lib/api.ts";
import {EventListing} from "@/types/event.ts";

// ---- Fetcher ----
async function fetchEvents(
    number: number,
    size: number,
    sort: Sort,
): Promise<Page<EventListing>> {
    const params = new URLSearchParams();
    params.set("page", String(number));
    params.set("size", String(size));
    params.set("sort", `${sort.field},${sort.dir}`);

    return api.get('https://app.nam-events.com/api/v2/public/events', {params})
        .then(({data}) => normalizePage<EventListing>(data));
}

// ---- Hooks ----
type UseEventsOpts = {
    page: number;
    size: number;
    sort: Sort;
    queryOptions?: Omit<
        UseQueryOptions<Page<EventListing>, Error, Page<EventListing>, any[]>,
        "queryKey" | "queryFn"
    >;
}

// ---- Hook Implementation ----
export function useEvents(opts: UseEventsOpts) {
    const {page, size, sort} = opts;
    // @ts-ignore
    return useQuery<Page<EventListing>, Error>({
        queryKey: ["public-events", page, size, sort],
        queryFn: () => fetchEvents(page, size, sort),
        staleTime: 60_000,
        refetchOnWindowFocus: false,
        ...opts.queryOptions,
    });
}
